import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-placetype-edit-modal',
  templateUrl: './placetype-edit-modal.component.html',
  styleUrls: ['./placetype-edit-modal.component.css']
})
export class PlacetypeEditModalComponent implements OnInit {
  @Input() placeType: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSavePlaceType(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
